import { Button, Card, Collapse, Descriptions, Form, Input, InputNumber, Modal, Tabs } from 'antd'
import { EmailTemplateApi } from 'api/EmailTemplate'
import EmailForm from 'components/Main/Emails/EmailForm'
import FooterButtons from 'elements/Buttons/FooterButtons'
import useFetch from 'elements/Hooks/useFetch'
import useModalShow from 'elements/Hooks/useModalShow'
import useSubmit from 'elements/Hooks/useSubmit'
import { get, pick } from 'lodash'
import { fullWidthFormItemLayout } from 'modules/FormItems'
import React, { useState } from 'react'
import ReactHtmlParser from 'react-html-parser'
import CustomTable from '../../../elements/Table/CustomTable'

function TemplatesList(props) {
  const { data: list, fetching, fetch } = useFetch({
    url: '/emailTemplate',
  })

  const { visible, onShow: _onShow, onCancel: _onCancel, isNew } = useModalShow()
  const [current, setCurrent] = useState({})

  function onShow(object, type) {
    console.log(object, type)
    setCurrent(object)
    _onShow(object, type)
  }

  function onCancel(props) {
    setCurrent({})
    _onCancel(props)
  }

  const [submitting, submitFunc] = useSubmit(EmailTemplateApi.create)
  const [updating, updateFunc] = useSubmit(EmailTemplateApi.update)
  const [removing, removeFunc] = useSubmit(EmailTemplateApi.remove)

  async function submit() {
    const submitted = await submitFunc(current)
    if (submitted) {
      onCancel()
      fetch()
    }
  }

  async function remove() {
    const removed = await removeFunc({
      ...pick(current, ['_key', '_rev', '_id']),
    })
    if (removed) {
      onCancel()
      fetch()
    }
  }

  async function update() {
    const submitted = await updateFunc(current)
    if (submitted) {
      onCancel()
      fetch()
    }
  }

  const columns = [
    {
      Header: 'Title',
      accessor: 'fn',
      width: 150,
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    {
      Header: 'Body',
      accessor: 'body',
    },
  ]

  console.log(current)

  return (
    <>
      <Modal
        footer={
          <FooterButtons
            isNew={isNew}
            isEdit={!isNew}
            submit={submit}
            remove={remove}
            update={update}
            removing={removing}
            submitting={submitting || updating}
            title={'Templates'}
          />
        }
        title="Templates"
        width="90%"
        onCancel={onCancel}
        destroyOnClose
        visible={visible}>
        <Tabs defaultActiveKey="form">
          <Tabs.TabPane tab="Details" key="details">
            <Form.Item {...fullWidthFormItemLayout} label="Name">
              <Input
                defaultValue={get(current, 'fn')}
                onChange={(e) =>
                  setCurrent({
                    ...current,
                    fn: e.target.value,
                  })
                }
              />
            </Form.Item>
            <Form.Item {...fullWidthFormItemLayout} label="Info">
              <Collapse accordion>
                <Collapse.Panel header="Email Tags Descriptions" key="1">
                  <Descriptions title="" bordered column={2}>
                    <Descriptions.Item label="Email External Link">{`{{= newsletterLink}}`}</Descriptions.Item>
                    <Descriptions.Item label="Logo URL">{`{{= logo}}`}</Descriptions.Item>
                    <Descriptions.Item label="Main Image Pic">{`{{= image}}`}</Descriptions.Item>
                    <Descriptions.Item label="Email Body">{`{{= body}}`}</Descriptions.Item>
                    <Descriptions.Item label="Template ID">{`{{= templateID}}`}</Descriptions.Item>
                    <Descriptions.Item label="receiverEmail ">{`{{= receiverEmail}}`}</Descriptions.Item>
                    <Descriptions.Item label="unsubscribeLink ">{`{{= unsubscribeLink}}`}</Descriptions.Item>
                    <Descriptions.Item label="privacyMONDIALE ">{`{{= privacyMONDIALE}}`}</Descriptions.Item>
                  </Descriptions>
                </Collapse.Panel>
              </Collapse>
            </Form.Item>
            <Form.Item {...fullWidthFormItemLayout} label="Body">
              <Input.TextArea
                rows={30}
                defaultValue={get(current, 'body')}
                onChange={(e) =>
                  setCurrent({
                    ...current,
                    body: e.target.value,
                  })
                }
              />
            </Form.Item>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Email Preview" key="preview">
            <div className="px-10 py-4">{ReactHtmlParser(current?.body || '')}</div>
          </Tabs.TabPane>
        </Tabs>
      </Modal>
      <CustomTable
        data={list}
        defaultPageSize={20}
        isFilterable={true}
        fetching={fetching}
        fetch={fetch}
        CreateButton={() => (
          <Button type="primary" onClick={() => onShow()}>
            New Templates
          </Button>
        )}
        columns={columns}
        defaultSorted={[
          {
            id: '_key',
            desc: false,
          },
        ]}
      />
    </>
  )
}

export default TemplatesList
